import type { HttpClient } from '@/shared/interfaces/http-client'
import { ventasApi } from '@/shared/lib/axios'

import { AxiosAdapter } from './axios-adapter'

export const httpClient = new AxiosAdapter(ventasApi)

export abstract class HttpService {
  constructor(protected readonly http: HttpClient = httpClient) {}
}
